import { render, staticRenderFns } from "./RegistrationBlock.vue?vue&type=template&id=09414a66"
import script from "./RegistrationBlock.vue?vue&type=script&lang=js"
export * from "./RegistrationBlock.vue?vue&type=script&lang=js"
import style0 from "./RegistrationBlock.vue?vue&type=style&index=0&id=09414a66&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09414a66')) {
      api.createRecord('09414a66', component.options)
    } else {
      api.reload('09414a66', component.options)
    }
    module.hot.accept("./RegistrationBlock.vue?vue&type=template&id=09414a66", function () {
      api.rerender('09414a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Incubator/RegistrationBlock.vue"
export default component.exports